import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PesosComponent} from '../pesos.component'
//Services
import {WeightService} from 'src/app/core/services/parameters/weight.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarPesoModal implements OnInit {

  editWeightForm: FormGroup;
  loading = false;
  showAlert = false;
  weightId;
  weightData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<PesosComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private weightService: WeightService
  ) {
  }

  ngOnInit(): void {
    this.editWeightForm = this.fb.group({
      weight: [, Validators.required]
    })
    this.weightId = this.data.id;
    this.weightService.getWeightById(this.weightId).subscribe(_res => {
      this.weightData = _res;
      this.editWeightForm.patchValue({
        weight: _res.name
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editWeightForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editWeightForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.weight
      }
      this.weightService.updateWeight(this.weightId, data).subscribe(_res => {
        this.alert.setNotice('Peso actualizado correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar el peso', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
